import http from "../../plugins/axios";

export default {
    getTenantList(data) {
        return http.get({
            url: `/la/admin/tenant/list`,
            data,
        });
    },

    addTenant(data) {
        return http.post({
            url: '/la/admin/tenant/add',
            data
        })
    },

    updaTenant(data) {
        return http.post({
            url: `/la/admin/tenant/update`,
            data
        })
    },


    updateContract(data) {
        return http.post({
            url: `/la/admin/tenant/updateContract`,
            data, dataType: 'form'
        })
    },

    updateLever(data) {
        return http.post({
            url: `/la/admin/tenant/updateLever`,
            data, dataType: 'form'
        })
    },

    updateOtc(data) {
        return http.post({
            url: `/la/admin/tenant/updateOtc`,
            data, dataType: 'form'
        })
    },

    updateSpot(data) {
        return http.post({
            url: `/la/admin/tenant/updateSpot`,
            data, dataType: 'form'
        })
    },

    updateFund(data) {
        return http.post({
            url: `/la/admin/tenant/updateFund`,
            data, dataType: 'form'
        })
    },

};
